export enum UserState {
  UNLOADED,
  NOT_AUTHENTICATED,
  SIGNIN,
  SIGNOUT,
}

export interface AuthState {
  authenticated: boolean;
  error?: string;
  status: UserState;
  fetchedLoginGql?: boolean;
  authReady: boolean;
}

export const initialState: AuthState = {
  status: UserState.UNLOADED,
  authenticated: false,
  fetchedLoginGql: false,
  authReady: false,
};

export type RootState = { auth: AuthState };
